<!--面板组件-->

<template>
  <div>
    <div class="overlay"></div>
    <div class="lightbox">
      <div class="modal_title">
        <slot name="modal_title"></slot>
      </div>
      <div class="modal_btn">
        <el-row>
          <el-button class="btns" type="primary" @click="toBack">{{
            lbtnName
          }}</el-button>
          <el-button class="btns" @click="doConfirm">{{ rbtnName }}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "ModelDisagree",
  components: {},
  data() {
    return {};
  },
  methods: {
    toBack() {
      this.$emit("toBack");
    },
    doConfirm(){
      this.$emit("doConfirm");
    }
  },
  props: ["lbtnName", "rbtnName"],
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.46);
}
.lightbox {
  background: #FFFFFF;
  border-radius: 10px;
  width: 526px;
  height: 190px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  padding: 16.11px 14.5px 40px 32px;
  text-align: center;
  .modal_title {
    margin-top: 20px;
    color: #2e2e2e;
  }
  .modal_btn {
    margin-top: 32px;
  }
  .btns {
    border-radius: 8px;
    height: 48px;
    width: 218px;
  }
}
</style>
